module.exports = __webpack_public_path__ + "static/img/pin-service-request-active.95659f3.svg";